import React from "react";
import { Tab } from "semantic-ui-react";
import { JOB_POST_TYPE } from "../../employer/employerConstanst";
import ReviewJobs from "./ReviewJobs";
import { useSelector } from "react-redux";
import {
  getAdmin,
  getExpiredJobToReview,
  getJobPromotionalRequests,
  getPaidJobsUnderReview,
  getUnderReviewFreebiesJobs,
} from "../adminSelectors";
import ReviewPromotionalRequests from "./ReviewPromotionalRequests";

export default function ReviewJobPosts() {
  const { jobs, underReviewFreebies } = useSelector((state) => getAdmin(state));

  const jobsToReviewCount =
    getPaidJobsUnderReview(jobs).length +
    getUnderReviewFreebiesJobs(underReviewFreebies).length;

  const expiredJobsCount = getExpiredJobToReview(jobs).length;

  const promotionalRequestsCount = getJobPromotionalRequests(jobs).length;

  const panes = [
    {
      menuItem: `Review (${jobsToReviewCount})`,
      render: () => (
        <Tab.Pane>
          <ReviewJobs type={JOB_POST_TYPE.underReview} close={false} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: `Expired (${expiredJobsCount})`,
      render: () => (
        <Tab.Pane>
          <ReviewJobs type={JOB_POST_TYPE.expired} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: `Promotional Requests (${promotionalRequestsCount})`,
      render: () => (
        <Tab.Pane>
          <ReviewPromotionalRequests />
        </Tab.Pane>
      ),
    },
  ];

  return <Tab panes={panes} renderActiveOnly={true} />;
}
